import React, { useEffect, useState } from "react";

const CountdownTimerBar = ({
  duration,
  onTimerEnd,
}: {
  duration: number;
  onTimerEnd?: () => void;
}) => {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;

    if (timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else {
      onTimerEnd?.();
      clearInterval(interval);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [onTimerEnd, timeLeft]);

  const progressPercentage = (timeLeft / duration) * 100;

  return (
    <div className="flex flex-col items-center">
      <div className="w-full bg-gray-200 rounded-full h-4">
        <div
          className="bg-blue-600 h-4 rounded-full"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <div className="mt-2 text-lg">{timeLeft} seconds left</div>
    </div>
  );
};

export default CountdownTimerBar;
